import { Capacitor } from '@capacitor/core'
import { STORE_URLS } from '@/shared/hooks/use-app-version-flag'
import { getMobileOS } from '@/shared/helpers/device'

export function useAppDownloadBanner() {
  const isHidden = Capacitor.isNativePlatform()
  const mobileOS = getMobileOS()

  return {
    isHidden,
    showAppStore: mobileOS !== 'android',
    showGooglePlay: mobileOS !== 'ios',
    storeUrl: mobileOS === 'android' ? STORE_URLS.android : STORE_URLS.ios,
  }
}
